import type { FaireProductEntity } from "../../entity_types/product";

export const p_gnqcwdjxzh: FaireProductEntity = {
  token: "p_gnqcwdjxzh",
  type: "product",
  name: "celebrate notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/db97d7a24f2896af220962a390f801113930df731d9672d7319a9e8505db6627.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44e85f2fd75cd759546d7705276b9a253fd430042aa47068804344ec550db465.jpeg",
    "https://cdn.faire.com/fastly/807ef8c30515824305e4903129439770a3776cc735b8a4d8496dea414db7802e.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Send sweet birthday greetings to your loved ones. The celebrate notecards include charming watercolor illustrations of birthday party celebration favorites.\n\n * set of eight (or single) folded cards with envelopes \n * blank inside \n * 5.5 inch x 4.25 inch \n * printed on 120lb superfine paper \n * original artwork by Emily Lex ",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:12.025Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
